import dayjs from 'dayjs';

// "2026. 5. 6. 10:00" — 날짜+시간 (초 없음)
export function formatDateTime(value) {
  if (!value) return '-';
  const d = dayjs(String(value).replace(' ', 'T'));
  if (!d.isValid()) return '-';
  return d.format('YYYY. M. D. HH:mm');
}

// "2026. 5. 6." — 날짜만
export function formatDate(value) {
  if (!value) return '-';
  const d = dayjs(String(value).replace(' ', 'T'));
  if (!d.isValid()) return '-';
  return d.format('YYYY. M. D.');
}

// "10:00" — 시간만
export function formatTime(value) {
  if (!value) return '-';
  const d = dayjs(String(value).replace(' ', 'T'));
  if (!d.isValid()) return '-';
  return d.format('HH:mm');
}

// "5. 6. 10:00" — 월일+시간 (방문 이력 등 연도 생략)
export function formatShortDateTime(value) {
  if (!value) return '-';
  const d = dayjs(String(value).replace(' ', 'T'));
  if (!d.isValid()) return '-';
  return d.format('M. D. HH:mm');
}
